import { FC } from 'react';
import { StyleSheet, View } from 'react-native';

import { COLORS } from '../../../config/designSystem/Colors';
import { Caption1Bold, Caption1Reg, ParagraphMBold } from '../../../config/designSystem/typography';
import { SPACING } from '../../../config/designSystem/Spacing';
import { convertFromUtf16 } from '../../../utils/others/emoji';

/** figma: ❖ Progress streak (Activities & Challenges pt1) */
export interface ProgressStreakProps {
  days: { done: boolean }[];
  title?: string;
  encouragement?: string;
  /** chain only, without the card wrapper (congrats screens) */
  bare?: boolean;
}

const DAY_SIZE = 36;

const styles = StyleSheet.create({
  card: {
    backgroundColor: COLORS.surface.contrast,
    borderRadius: SPACING['sp-16'],
    borderWidth: 1,
    borderColor: COLORS.border.secondary,
    padding: SPACING['sp-16'],
    rowGap: SPACING['sp-16'],
    alignItems: 'center',
  },
  chain: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: SPACING['sp-8'],
    flexWrap: 'wrap',
  },
  day: {
    width: DAY_SIZE,
    height: DAY_SIZE,
    borderRadius: DAY_SIZE / 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dayDone: {
    backgroundColor: COLORS.state.success.primary,
  },
  dayCurrent: {
    backgroundColor: COLORS.content.accent,
  },
  dayUpcoming: {
    borderWidth: 1,
    borderColor: COLORS.border.secondary,
    backgroundColor: COLORS.surface.contrast,
  },
});

export const ProgressStreak: FC<ProgressStreakProps> = ({
  days,
  title,
  encouragement,
  bare,
}) => {
  const currentIndex = days.findIndex(day => !day.done);

  const renderDay = (day: { done: boolean }, index: number) => {
    if (day.done) {
      return (
        <View key={index} style={[styles.day, styles.dayDone]}>
          <Caption1Bold color={COLORS.content['inverse-primary']}>
            {convertFromUtf16('2713')}
          </Caption1Bold>
        </View>
      );
    }
    if (index === currentIndex) {
      return (
        <View key={index} style={[styles.day, styles.dayCurrent]}>
          <Caption1Bold color={COLORS.content['inverse-primary']}>
            {String(index + 1)}
          </Caption1Bold>
        </View>
      );
    }
    return (
      <View key={index} style={[styles.day, styles.dayUpcoming]}>
        <Caption1Reg color={COLORS.content.secondary}>
          {String(index + 1)}
        </Caption1Reg>
      </View>
    );
  };

  if (bare) {
    return (
      <View style={styles.chain}>
        {days.map(renderDay)}
      </View>
    );
  }
  return (
    <View style={styles.card}>
      {title ? <ParagraphMBold>{title}</ParagraphMBold> : null}
      <View style={styles.chain}>
        {days.map(renderDay)}
      </View>
      {encouragement ? (
        <Caption1Reg color={COLORS.content.secondary}>{encouragement}</Caption1Reg>
      ) : null}
    </View>
  );
};
